/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
/* eslint-disable import/prefer-default-export */
import { DropdownSelect } from 'components/generic/dropdown/DropdownSelect'
import React, { useEffect, useState, useMemo, useCallback } from 'react'
import { pluralize } from 'helpers/formatters'
import s from './LocationDropdown.module.css'

export function LocationDropdown(props) {
  const { selected_neighborhood, selected_regions } = props

  const [regions, setRegions] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    async function fetchRegions() {
      setIsLoading(true)
      try {
        const apiToken = localStorage.getItem('apiToken')

        const response = await fetch(`/api/v3/filters/regions.json`, {
          headers: {
            'API_TOKEN': apiToken,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'GET',
        })

        const data = await response.json()
        setRegions(data)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
      } finally {
        setIsLoading(false)
      }
    }

    fetchRegions()
  }, [])

  const options = useMemo(() => {
    if (!regions) {
      return []
    }

    return regions?.map((region) => ({
      label: (
        <div className={s.label}>
          <div className={s.regionName}>{region.name}</div> <div className={s.counter}>{region.listings_count}</div>
        </div>
      ),
      value: region.name,
      name: region.name,
      children: region.neighborhoods?.map((neighborhood) => ({
        label: (
          <div className={s.label}>
            <div className={s.regionName}>{neighborhood.name}</div>{' '}
            <div className={s.counter}>{neighborhood.listings_count}</div>
          </div>
        ),
        name: neighborhood.name,
        value: neighborhood.id,
      })),
    }))
  }, [regions])

  const handleApply = useCallback(
    (values) => {
      const regionList = values?.filter((value) => typeof value === 'string') // Brooklyn and etc.
      const neighborhoodsIds = values?.filter((value) => typeof value === 'number') // 12, 56, 615 and etc
      const regionIds = regions.filter((region) => regionList.includes(region.name))?.map((region) => region.id)

      const neighborhoodsHiddenInput = document.querySelector('#listing-neighborhood-values')
      neighborhoodsHiddenInput.value = neighborhoodsIds?.join(',')

      const regionsHiddenInput = document.querySelector('#listing_search_form_region_id_list')
      regionsHiddenInput.value = regionIds?.join(',')
    },
    [regions]
  )

  const handleClear = () => {
    const neighborhoodsHiddenInput = document.querySelector('#listing-neighborhood-values')
    neighborhoodsHiddenInput.value = ''

    const regionsHiddenInput = document.querySelector('#listing_search_form_region_id_list')
    regionsHiddenInput.value = ''
  }

  const selectedValues = useMemo(() => {
    const selectedRegionsArr = selected_regions?.split(',')?.map((region) => Number(region))
    const regionNames = regions
      ?.filter((region) => selectedRegionsArr.includes(region.id))
      ?.map((region) => region.name)

    return [...regionNames, ...selected_neighborhood?.map((neighborhood) => Number(neighborhood))]
  }, [selected_neighborhood, selected_regions, regions])

  return (
    <DropdownSelect
      className={s.root}
      inputPlaceholder="Where do you want to live?"
      options={options?.length > 0 ? options : []}
      values={selectedValues}
      onApply={handleApply}
      onClear={handleClear}
      selectedValuesFunc={(valuesNum) =>
        valuesNum > 0 ? pluralize(valuesNum, 'Neighborhood', 'Neighborhoods') : 'Neighborhoods'
      }
    />
  )
}
